import { UserModel } from '../../auth/models/user.model';

export class ButtonModel {
  public design: string;
  public spiritual: string;
  public spiritualText: string;
  public code: string;
  public value: string;
  public scannedCount: number;
  public gotByVoucher: boolean;
  public greetingsMessage: string;
  public giverFirstName: string;
  public giverLastName: string;

  public user: UserModel;

  public getSpiritualAnimatedImageUrl(): string {
    return (this.design && this.spiritual) ?
      '/assets/img/spirit_buttons/' + this.design + '_' + this.design + '_' + this.spiritual.replace('v', '') + '-png.gif' :
      null;
  }
  
  public getSpiritualImageUrl(): string {
    return (this.design && this.spiritual) ?
      '/assets/img/img_but/' + this.design + '_' + this.spiritual.replace('v', '') + '.png' :
      null;
  }
  
  public getSpiritualImageUrlNoBackground(): string {
    return (this.design && this.spiritual) ?
      '/assets/img/img_but_no_bg/' + this.design + '_' + this.spiritual.replace('v', '') + '.png' :
      null;
  }

  public getDesignImageUrl(): string {
    return this.design ? '/assets/img/' + this.design + '.png' : null;
  }

  public getDesignAnimatedImageUrl(): string {
    return this.design ? '/assets/img/animierte_buttons/button_' + this.design + '_gif.gif' : null;
  }
}


// WEBPACK FOOTER //
// ./src/app/buttons/models/button.model.ts